import * as React from 'react';
import Select, { components } from 'react-select';

const CheckboxOption = (props) => {
  const { data, innerRef, innerProps, isFocused, children } = props;
  return (
    <components.Option {...props}>
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          paddingLeft: data.padded ? '10px' : '2px',
          fontWeight: data.isGroup ? 'bold' : 'normal',
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center'
        }}
      >
        <input
          style={{
            margin: '0 3px 0 0',
          }}
          type="checkbox" readOnly checked={data.checked} /> {children}
      </div>
    </components.Option>
  );
};

const CustomMultiValue = (props) => {
  const selectedItemsLength = props.selectProps.value.length
  const coma = props.index + 1 !== selectedItemsLength ? ', ' : '';

  return (props.data.label + coma)
};

class SelectCheckbox extends React.Component {
  static defaultProps = {
    placeholder: 'Select a value',
  };

  render() {
    const { textValue, ...attrs } = this.props;

    return (
      <Select
        isMulti
        isSearchable={false}
        styles={{
          valueContainer: (provided) => ({
            ...provided,
            flexWrap: 'nowrap',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          }),
          multiValue: (provided) => ({
            ...provided,
            display: 'inline-flex',
            marginRight: '2px',
            background: '#FFFFFF00'
          }),
        }}
        isClearable={false}
        hideSelectedOptions={false}
        components={{
          MultiValueRemove: () => null,
          Option: CheckboxOption,
          MultiValue: CustomMultiValue,
        }}
        {...attrs}
      />
    );
  }
}

export default SelectCheckbox;
